// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import { Helmet } from 'react-helmet';
import { getPublicSetting } from '../actions/settings/settingsCreators';
import Banner from '../components/Banner';
import Header from '../components/Header';
import type { Dispatch } from 'redux';

type Props = {
  settings: Object,
  authentication: Object,
  getPublicSetting: (s: string) => void
};

class Welcome extends React.Component<Props> {
  componentDidMount() {
    const { getPublicSetting } = this.props;
    getPublicSetting('registrationVideo');
  }

  render() {
    const { settings, authentication } = this.props;
    if (!authentication || !authentication.isLoggedIn) {
      return (
        <div className="App Welcome" aria-live="polite">
          <Header />
          <Banner title="Welcome to Campaign Targeter" />

          <Grid fluid>
            <Row className="section primary-background text-center">
              <Col sm={2} md={2} mdOffset={1} lg={2} lgOffset={2}>
                <Link to="/login" className="back-link">
                  &#11104; Back to Login
                </Link>
                <br />
              </Col>
              <Col sm={8} md={6} lg={4}>
                {settings &&
                  settings.registrationVideo && (
                    <iframe
                      width="560"
                      height="315"
                      src={settings.registrationVideo.value}
                      frameBorder="0"
                      allowFullScreen
                      title="Test"
                    />
                  )}
              </Col>
            </Row>
          </Grid>
        </div>
      );
    }
    return (
      <div className="App Welcome" aria-live="polite">
        <Helmet>
          <title>Welcome | Campaign Targeter</title>
        </Helmet>
        <Header />
        <Banner title="Welcome to Campaign Targeter" />

        <Grid>
          <Row className="section primary-background text-center">
            <Col md={8} mdOffset={2}>
              {settings &&
                settings.registrationVideo && (
                  <iframe
                    width="560"
                    height="315"
                    src={settings.registrationVideo.value}
                    frameBorder="0"
                    allowFullScreen
                    title="Test"
                  />
                )}
            </Col>
          </Row>
          {authentication &&
            authentication.isLoggedIn && (
              <Row className="section primary-background">
                <Col md={8} mdOffset={2} className="text-center">
                  <LinkContainer to="/">
                    <Button bsStyle="primary">Skip</Button>
                  </LinkContainer>
                </Col>
              </Row>
            )}
        </Grid>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      getPublicSetting
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);



// WEBPACK FOOTER //
// ./src/containers/Welcome.js